(function () {
  const SESSION_KEY = 'quiz_popup_dismissed';
  const PENDING_KEY = 'quiz_popup_pending_success';

  const overlay = document.getElementById('quiz-popup-overlay');
  if (!overlay) return;

  const modal = overlay.querySelector('.quiz-popup-modal');
  const progressWrap = modal.querySelector('.quiz-progress-wrap');
  const progressBar = modal.querySelector('.quiz-progress-bar');

  const activeQuestions = (overlay.dataset.activeQuestions || '')
    .split('|')
    .filter(Boolean);

  const webhookUrl = overlay.dataset.webhookUrl || '';
  const quizAnswers = {};

  function getQuestionLabel(step) {
    var el = getStepEl(step);
    var titleEl = el && el.querySelector('.quiz-question-title');
    return titleEl ? titleEl.textContent.trim() : step;
  }

  function getStepEl(step) {
    return overlay.querySelector('[data-step="' + step + '"]');
  }

  function showStep(step) {
    overlay.querySelectorAll('.quiz-step').forEach(function (el) {
      el.classList.remove('quiz-step--active');
    });
    var el = getStepEl(step);
    if (el) {
      el.classList.add('quiz-step--active');
      modal.scrollTop = 0;
    }
    updateProgressBar(step);
  }

  function updateProgressBar(step) {
    if (!progressBar || !progressWrap) return;

    var showProgress = step !== 'intro' && step !== 'success';
    progressWrap.style.display = showProgress ? 'block' : 'none';

    if (!showProgress || activeQuestions.length === 0) return;

    var idx = activeQuestions.indexOf(step);
    var pct = idx >= 0 ? Math.round(((idx + 1) / activeQuestions.length) * 100) : 100;
    progressBar.style.width = pct + '%';
  }

  function openPopup(step) {
    overlay.classList.add('is-visible');
    showStep(step);
  }

  function closePopup() {
    overlay.classList.remove('is-visible');
    sessionStorage.setItem(SESSION_KEY, '1');
  }

  /* ---------- Event handlers (always attached) ---------- */

  var closeBtn = overlay.querySelector('.quiz-popup-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closePopup);
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  var startBtn = overlay.querySelector('.quiz-start-btn');
  if (startBtn) {
    startBtn.addEventListener('click', function () {
      showStep(activeQuestions.length > 0 ? activeQuestions[0] : 'email');
    });
  }

  // Question option clicks → advance to next step
  activeQuestions.forEach(function (qStep, idx) {
    var stepEl = getStepEl(qStep);
    if (!stepEl) return;

    stepEl.querySelectorAll('.quiz-option').forEach(function (option) {
      option.addEventListener('click', function () {
        stepEl.querySelectorAll('.quiz-option').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        option.classList.add('is-selected');
        quizAnswers[qStep] = option.textContent.trim();

        setTimeout(function () {
          showStep(activeQuestions[idx + 1] || 'email');
        }, 420);
      });
    });
  });

  /* ---------- Email form (native Shopify customer form) ---------- */

  var form = overlay.querySelector('.quiz-email-form');
  var emailInput = overlay.querySelector('.quiz-email-input');
  var emailError = overlay.querySelector('.quiz-email-error');
  var submitBtn = overlay.querySelector('.quiz-submit-btn');

  // Sends email + quiz answers to an external webhook (e.g. a Google Apps
  // Script Web App) so every submission also lands as a row in a spreadsheet.
  // Fire-and-forget: uses fetch's keepalive flag so the request survives the
  // native form's full page navigation to /contact. sendBeacon is avoided as
  // the primary method here because it does not reliably follow the redirect
  // Apps Script Web Apps issue before running doPost, which silently drops
  // the submission.
  function sendSubmissionWebhook(email) {
    if (!webhookUrl) return;

    var payload = { email: email, submitted_at: new Date().toISOString(), page_url: window.location.href };
    activeQuestions.forEach(function (qStep) {
      payload[qStep + '_question'] = getQuestionLabel(qStep);
      payload[qStep + '_answer'] = quizAnswers[qStep] || '';
    });

    var body = JSON.stringify(payload);
    if (window.fetch) {
      fetch(webhookUrl, { method: 'POST', mode: 'no-cors', keepalive: true, body: body }).catch(function () {});
    } else if (navigator.sendBeacon) {
      navigator.sendBeacon(webhookUrl, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
    }
  }

  if (form && emailInput) {
    // Let the form submit natively (full page POST to /contact) — exactly like
    // the footer email signup. We only flag a pending success so the popup can
    // re-open on the thank-you step after Shopify redirects back to the page.
    form.addEventListener('submit', function (e) {
      var email = (emailInput.value || '').trim();

      if (!email || !isValidEmail(email)) {
        e.preventDefault();
        emailInput.classList.add('is-error');
        if (emailError) emailError.style.display = 'block';
        return;
      }

      sendSubmissionWebhook(email);
      sessionStorage.setItem(PENDING_KEY, '1');

      // Defer the disabled/label change so it doesn't interfere with submission.
      setTimeout(function () {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending…';
        }
      }, 0);
      // No preventDefault — native submit proceeds.
    });

    emailInput.addEventListener('input', function () {
      emailInput.classList.remove('is-error');
      if (emailError) emailError.style.display = 'none';
    });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* ---------- Decide what to show on load ---------- */

  // Returning from a successful subscription → show the thank-you step,
  // ignoring the normal session dismiss guard.
  if (sessionStorage.getItem(PENDING_KEY)) {
    sessionStorage.removeItem(PENDING_KEY);
    sessionStorage.setItem(SESSION_KEY, '1');
    openPopup('success');
    return;
  }

  // Already dismissed this session → don't show again.
  if (sessionStorage.getItem(SESSION_KEY)) return;

  setTimeout(function () {
    openPopup('intro');
  }, 800);
})();
